import { css } from '@emotion/react';

export default css`
  @font-face {
    font-family: 'Poppins-Fallback';
    src: local(Verdana);
    size-adjust: 103%;
    ascent-override: 90%;
    descent-override: 20%;
    line-gap-override: 39%;
  }

  @font-face {
    font-display: swap;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: local(Poppins Regular),
      local(Poppins-Regular),
      url('/fonts/poppins-latin-regular.woff2') format('woff2');
  }

  @font-face {
    font-display: swap;
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 400;
    src: local(Poppins Regular),
      local(Poppins-Regular),
      url('/fonts/poppins-latin-italic.woff2') format('woff2');
  }

  @font-face {
    font-display: swap;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    src: local(Poppins Medium),
      local(Poppins-Medium),
      url('/fonts/poppins-latin-500.woff2') format('woff2');
  }

  @font-face {
    font-display: swap;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    src: local(Poppins SemiBold),
      local(Poppins-SemiBold),
      url('/fonts/poppins-latin-600.woff2') format('woff2');
  }

  @font-face {
    font-display: swap;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    src: local(Poppins Bold),
      local(Poppins-Bold),
      url('/fonts/poppins-latin-700.woff2') format('woff2');
  }
`;
